import React from 'react';
import { min } from 'underscore';
import { getLcn } from '~/utils/labeled-classnames';

const maxSizes = {
  xxs: 'max-w-[400px]',
  xs: 'max-w-[600px]',
  sm: 'max-w-[800px]',
  md: 'max-w-[1000px]',
  lg: 'max-w-[1200px]',
  xl: 'max-w-[1400px]',
} as const;

const minSizes = {
  none: '',
  xs: 'sm:min-w-[400px]',
} as const;

export function CenteredSection({
  size = 'md',
  children,
  className,
  minSize = 'xs'
}: {
  size?: keyof typeof maxSizes,
  minSize?: keyof typeof minSizes
  children: React.ReactNode,
  className?: string,
}) {
  const lcn = getLcn({
    centeredSection: [
      'w-full', // makes sure the max-w is met regardless of the content size
      'sm:mx-auto',
      maxSizes[size],
      minSizes[minSize],
      className
    ]
  });

  return (
    <div className={lcn.centeredSection}>
      {children}
    </div>
  );
}; 